import { useMutation } from '@tanstack/react-query';
import type { CreatePrestigeConfigurationParams } from '@core';
import { serviceHost } from '@services';

export const useCreatePrestigeConfiguration = () =>
  useMutation({
    mutationFn: async (params?: CreatePrestigeConfigurationParams) => {
      await serviceHost.getAuthenticationService().ensureAnonymousSignIn();
      return serviceHost
        .getFunctionsService()
        .createPrestigeConfiguration(params);
    },
  });
